export enum State {
  NEW = 'NEW',
  MODIFIED = 'MODIFIED',
  DELETED = 'DELETED',
  EMPTY = 'EMPTY'
}
